<template>
  <transition tag="div" name="fade" mode="out-in">
    <div id="pay-container" v-if="canShowContent">
      <div class="c-head">
        <!-- <a href="javascript:void(0);" class="c-head_back"></a> -->
        <a href="javascript:void(0);" class="c-head_logo"></a>
        <div class="logout" @click="goLogOut" v-if="isSdk == '0'">切換帳號</div>
      </div>
      <div class="o-store-channel">
        <!-- 对象：储值信息 -->
        <div class="o-item o-info">
          <div
            class="o-item_head"
            @click.prevent="infoIsActive = !infoIsActive"
          >
            <span class="o-item_ibox o-info_ibox">
              <i class="o-item_ibox-user"></i>
            </span>
            <p class="o-item_info">
              <a href class="o-item_uname">{{ userInfo.userName }}</a>
              <span class="hello">您好~</span>
            </p>
            <p class="o-item_title">
              儲值信息
              <i
                v-bind:class="[infoIsActive ? 'o-item_up' : 'o-item_down']"
              ></i>
            </p>
          </div>
          <transition
            name="store-info-transition"
            enter-active-class="animated bounceIn"
            leave-active-class="animated bounceOut"
            v-on:leave="infoLeave"
          >
            <div class="o-item_body o-info_body" v-if="infoIsActive">
              <!-- 组件：form表单 -->
              <div class="c-form">
                <div class="c-form_group" @click.prevent="showGame">
                  <i class="c-form_icon c-f_game"></i>
                  <p class="c-form_ctrl">{{ dialog.ctrl.game.txt }}</p>
                  <span class="c-form_sbox">
                    <i
                      :class="[
                        dialog.id == 'game' ? 'c-form_up' : 'c-form_down'
                      ]"
                    ></i>
                  </span>
                </div>
                <div
                  class="c-form_group j-select-server-dcount"
                  @click.prevent="showSfq"
                >
                  <i class="c-form_icon c-f_sfq j-select-server-dcount"></i>
                  <p class="c-form_ctrl j-select-server-dcount">
                    {{ dialog.ctrl.sfq.txt }}
                  </p>
                  <span class="c-form_sbox j-select-server-dcount">
                    <i
                      class="j-select-server-dcount"
                      :class="[
                        dialog.id == 'sfq' ? 'c-form_up' : 'c-form_down'
                      ]"
                    ></i>
                  </span>
                </div>
                <div
                  class="c-form_group j-select-role-dcount"
                  @click.prevent="showRole"
                >
                  <i class="c-form_icon c-f_role j-select-role-dcount"></i>
                  <p class="c-form_ctrl j-select-role-dcount">
                    {{ dialog.ctrl.role.txt }}
                  </p>
                  <span class="c-form_sbox j-select-role-dcount">
                    <i
                      class="j-select-role-dcount"
                      :class="[
                        dialog.id == 'role' ? 'c-form_up' : 'c-form_down'
                      ]"
                    ></i>
                  </span>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <!-- 对象：储值地区 -->
        <div class="o-item o-location">
          <div class="o-item_head j-area-dcount" @click="controlAreaShow">
            <span class="o-item_ibox o-location_ibox j-area-dcount">
              <i class="o-item_ibox-location"></i>
            </span>
            <p class="o-item_info j-area-dcount">國家或地區</p>
            <p class="o-item_title j-area-dcount">
              {{ curLocation }}
              <i
                v-bind:class="[showAreaSelector ? 'o-item_up' : 'o-item_down']"
              ></i>
            </p>
            <!-- <p class="o-item_title">dialog.ctrl.region.txt<i class="o-item_up"></i></p> -->
          </div>
        </div>
        <!-- 对象：储值渠道 -->
        <div class="o-item o-chnl">
          <!-- 组件：储值渠道列表 -->
          <div class="o-item_head">
            <span class="o-item_ibox o-chnl_ibox">
              <i class="o-item_ibox-dollar"></i>
            </span>
            <p class="o-item_info">儲值渠道</p>
            <a
              v-show="!showPayWaySelecter && curPrice != ''"
              href="javascript:void(0);"
              @click="controlDisplay"
              class="o-item_title j-paytype2-dcount j-chang-chanel"
            >
              更換
              <i class="o-chnl_change j-paytype1-dcount j-chang-chanel"></i>
            </a>
          </div>
          <!-- 选渠道 -->
          <PayWaySelecter
            v-show="showPayWaySelecter"
            :curPayType="curPayType"
            :allPayTypes="allPayTypes"
            v-bind:showChildSelector="showPayWaySelecter"
            v-on:selectPayWay="selectPayType"
          ></PayWaySelecter>
          <!-- 所选渠道详情/除银行外 -->
          <div
            class="o-item_body o-chnl_body"
            v-if="!showPayWaySelecter && curPrice != '' && !showBank"
          >
            <div class="c-chnl-box o-bank">
              <h3 class="c-chnl-box_title">
                <img
                  v-if="curPayType.f_pay_type"
                  :src="iconURL"
                  class="c-chnl-box_icon o-chnl-icon_pp"
                />
                <span class="c-chnl-box_txt">{{ curPayType.name }}</span>
              </h3>
              <div class="c-chnl-form" v-if="!showPointCardEditor">
                <div class="c-chnl-form_group">
                  <span class="c-chnl-form_type">金額：</span>
                  <div
                    class="c-chnl-form_ctrl j-money-dcount j-select-payment"
                    @click="showPaymentSelecter = true"
                  >
                    <p
                      v-if="undefined == curPrice"
                      class="j-money-dcount j-select-payment mark-placeholder c-chnl-form_ipt"
                    >
                      請選擇付款金額
                    </p>
                    <p
                      v-if="undefined != curPrice"
                      class="c-chnl-form_ipt j-money-dcount"
                      v-fixing
                    >
                      <span class="red-color">
                        {{ curPrice.TRANS_AMOUNT }}
                        {{ curPayType ? curPayType.show_currency : '' }}
                      </span>
                      <span style="margin: 0 5px" v-if="curPrice.PRODUCT_TYPE">
                        =
                      </span>
                      <span
                        v-if="
                          curPrice.PRODUCT_TYPE == 'coin' &&
                          curPrice.FIRST_PAY == 1 &&
                          curPrice.EXTRA_COIN != 0
                        "
                      >
                        {{ curPrice.SUB_COIN }}
                        <i style="color: red">
                          x 2 + {{ curPrice.EXTRA_COIN
                          }}{{ coinName || '元寶' }}
                        </i>
                      </span>
                      <span
                        v-if="
                          curPrice.PRODUCT_TYPE == 'coin' &&
                          curPrice.FIRST_PAY == 1 &&
                          curPrice.EXTRA_COIN == 0
                        "
                      >
                        {{ curPrice.SUB_COIN }}
                        <i style="color: red">x 2{{ coinName || '元寶' }}</i>
                      </span>
                      <span
                        v-if="
                          curPrice.PRODUCT_TYPE == 'coin' &&
                          curPrice.FIRST_PAY !== 1 &&
                          curPrice.EXTRA_COIN != 0
                        "
                      >
                        {{ curPrice.SUB_COIN }}
                        <i style="color: red">
                          + {{ curPrice.EXTRA_COIN }}{{ coinName || '元寶' }}
                        </i>
                      </span>
                      <span
                        v-if="
                          curPrice.PRODUCT_TYPE == 'coin' &&
                          curPrice.FIRST_PAY !== 1 &&
                          curPrice.EXTRA_COIN == 0
                        "
                      >
                        {{ curPrice.SUB_COIN }}{{ coinName || '元寶' }}
                      </span>
                      <span
                        v-if="
                          curPrice.PRODUCT_TYPE == 'coin' &&
                          curPrice.FIRST_PAY == 1
                        "
                        style="margin: 0 5px"
                      >
                        <i style="color: red">(首儲雙倍)</i>
                      </span>
                      <span v-if="curPrice.PRODUCT_TYPE == 'package'">
                        {{
                          curPrice.CP_PRODUCT_DESC +
                          (curPrice.PRODUCT_EXTRA_DESC
                            ? '-' + curPrice.PRODUCT_EXTRA_DESC
                            : '') +
                          (curPrice.PRODUCT_DESC
                            ? '(' + curPrice.PRODUCT_DESC + ')'
                            : '')
                        }}
                      </span>
                    </p>
                    <span
                      class="c-chnl-form_sbox j-money-dcount j-select-payment"
                    >
                      <i
                        class="c-chnl-form_down j-money-dcount j-select-payment"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
              <p class="package-tips" v-if="showPackageTips">
                禮包僅支持單張面額等於或大於禮包售價之點卡購買，超出部分將以元寶形式發放。
              </p>
              <div class="c-qr" v-if="!showPointCardEditor">
                <button class="c-qr_btn j-select-pp-confirm" @click="checkInfo">
                  確認付款
                </button>
              </div>
              <!-- 点卡输入 -->
              <PointCard
                v-if="curPrice != undefined && showPointCardEditor"
                @payWidthPointCard="payWidthPointCard"
                v-bind:type="curPayType.type"
                v-bind:amount="curPrice.TRANS_AMOUNT + ' ' + curPrice.CURRENCY"
              ></PointCard>
            </div>
          </div>
          <!-- 银行卡汇款 -->
          <bank v-if="showBank" :iconURL="iconURL"></bank>
          <!-- 统一提示 -->
          <tips :tip="tip"></tips>
          <!-- 订单详情 -->
          <transition name="fade">
            <div class="select-container" v-if="showOrderDetail">
              <div class="bg j-bg" @click="showOrderDetail = false"></div>
              <section class="c-pop">
                <div class="o-pay">
                  <p class="o-pay_info">
                    <span class="o-pay_key">遊戲名稱：</span>
                    <span class="o-pay_value">日理萬姬</span>
                  </p>
                  <p class="o-pay_info">
                    <span class="o-pay_key">服務器：</span>
                    <span class="o-pay_value">{{ dialog.ctrl.sfq.txt }}</span>
                  </p>
                  <p class="o-pay_info">
                    <span class="o-pay_key">角色名：</span>
                    <span class="o-pay_value">{{ dialog.ctrl.role.txt }}</span>
                  </p>
                  <p class="o-pay_info">
                    <span class="o-pay_key">儲值金額：</span>
                    <span class="o-pay_value">
                      {{ curPrice.TRANS_AMOUNT }}
                      {{ curPayType ? curPayType.show_currency : '' }}
                    </span>
                  </p>
                  <div class="c-qr">
                    <button
                      class="c-qr_btn j-submit-dcount j-submit-paypal"
                      @click="postOrder"
                    >
                      確認付款
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </transition>
        </div>
      </div>
      <dialogs :dialog="dialog" :pays="pays"></dialogs>
      {{ postAction }}
      <form v-bind:action="postAction" method="post">
        <input
          type="hidden"
          name="cardType"
          v-bind:value="post_fields.cardType"
        />
        <input
          type="hidden"
          name="gatewayNo"
          v-bind:value="post_fields.gatewayNo"
        />
        <input
          type="hidden"
          name="goodsInfo"
          v-bind:value="post_fields.goodsInfo"
        />
        <input type="hidden" name="merNo" v-bind:value="post_fields.merNo" />
        <input
          type="hidden"
          name="notifyUrl"
          v-bind:value="post_fields.notifyUrl"
        />
        <input
          type="hidden"
          name="orderAmount"
          v-bind:value="post_fields.orderAmount"
        />
        <input
          type="hidden"
          name="orderCurrency"
          v-bind:value="post_fields.orderCurrency"
        />
        <input
          type="hidden"
          name="orderNo"
          v-bind:value="post_fields.orderNo"
        />
        <input type="hidden" name="remark" v-bind:value="post_fields.remark" />
        <input
          type="hidden"
          name="returnUrl"
          v-bind:value="post_fields.returnUrl"
        />
        <input
          type="hidden"
          name="shopperId"
          v-bind:value="post_fields.shopperId"
        />
        <input
          type="hidden"
          name="signInfo"
          v-bind:value="post_fields.signInfo"
        />
        <input type="hidden" name="token" v-bind:value="post_fields.token" />
        <input
          type="hidden"
          name="verifyBillingAddress"
          v-bind:value="post_fields.verifyBillingAddress"
        />
        <button type="submit" id="postOrderToBank" class="hide"></button>
      </form>
      <transition name="fade">
        <Dialog v-show="showDialog"></Dialog>
      </transition>
      <transition name="fade">
        <AreaSelecter
          v-show="showAreaSelector"
          v-on:closeSelecter="showAreaSelector = false"
          v-on:hideAreaSelector="hideAreaSelector"
          v-bind:showChildSelector="showAreaSelector"
          :locations="locations"
        ></AreaSelecter>
      </transition>
      <transition name="fade">
        <PaymentSelecter
          v-show="showPaymentSelecter"
          v-on:closeSelecter="showPaymentSelecter = false"
          :curPayType="curPayType"
          :curPrice="curPrice"
          :pricesList="pricesList"
          v-bind:showChildSelector="showPaymentSelecter"
          v-on:selectPayMent="selectPayMent"
        ></PaymentSelecter>
      </transition>
      <transition name="fade">
        <div class="loading-mask pay" v-if="boolPaying">
          <div class="loading">
            <span class="loading-item"></span>
            <span class="loading-item"></span>
            <span class="loading-item"></span>
            <span class="loading-item"></span>
            <span class="loading-item"></span>
          </div>
        </div>
      </transition>
      <div class="add-tips">
        <p>
          1、購買禮包的額度超過禮包的價格，剩餘部分會按照1:2的比例自動轉換為元寶
        </p>
        <p>2、購買禮包的額度不足會導致交易失敗，請提交工單進行處理。</p>
        <p style="color: red">*切記！購買禮包額度務必要正確*</p>
      </div>
    </div>
    <div class="loading-mask" v-else>
      <div class="loading">
        <span class="loading-item"></span>
        <span class="loading-item"></span>
        <span class="loading-item"></span>
        <span class="loading-item"></span>
        <span class="loading-item"></span>
      </div>
    </div>
  </transition>
</template>
<style lang="scss">
@import '../../assets/scss/base.scss';
@import '../../assets/scss/comom.scss';
@import '../../assets/scss/twStore/twStore.scss';
</style>
<script>
import { mapMutations } from 'vuex';
import PayWaySelecter from '../../components/twStore/PayWaySelecter';
import AreaSelecter from '../../components/twStore/AreaSelecter';
import bank from '../../components/twStore/bank';
import PaymentSelecter from '../../components/twStore/PaymentSelecter';
import PointCard, {
  NEED_PIN_ONLY,
  NEED_PIN_SERIAL
} from '../../components/twStore/PointCard';
import qs from 'qs';
import Dialog from '../../components/passport/Dialog';
import bridge from '../../utiles/bridge';
import { STORE_PAGE_BASE_URL, RES_HOST, FEEKBACK_URL } from '../../utiles';
import dialogs from '../../components/twStore/dialog';
import Api from '../../utiles/twStore/js/common/api.js';
import tips from '../../components/twStore/tips.vue';

import {
  RELOAD_WAY_BY_LOCA,
  POST_ORDER,
  GET_LOGIN_STATUS,
  LOAD_INIT_DATA,
  GO_LOGOUT
} from '../../store/twStore';

import {
  getPayTYpeListStore,
  getServerId,
  getCoinName,
  setDefaultPayType,
  getLocationNameByVal,
  setDefaultPrice,
  storeCurLocation,
  storeHrefParam,
  setWebviewPageFlag,
  storeHref,
  setPostInfo,
  getIsSdk
} from '../../store/twStore/storager';
import globalConfig from '../../utiles/globalConfig';
import {
  getGlobalGetGotoLink,
  getGlobalGetLinkParams
} from '@utiles/globalGetLink';
import { updateCommonParamsInfo } from '@plugins/biPoint/commonParam';
const PAY_REQUEST_GET = 1;
const PAY_REQUEST_POST = 2;
const SHOW_RESULT_PAGE = 5;
const BROWSER_PAY = 11;
const OPEN_BROSWER_METHOD = 'openBrowser';
const TW_STORE_LANG = 'zh-TW';
const mainHost = globalConfig.getMainHost();

/*
   支付页面可以无数个入口，但是每个入口必须往sessionStorage 中缓存一下信息：
   地区列表
   当前地区的值（locations name:value 中的value）
   渠道列表
   当前渠道
   价格列表（当前渠道中的priceList）
   当前价格（储值结果页面可能存储了，没有，就显示默认第一个）
   coin_name 初始化数据在别的页面加载
   商品列表
   当前商品信息（根据链接上的商品信息，从商品列表中获取）
*/

export default {
  data() {
    let ourServerId = getServerId();
    // eslint-disable-next-line camelcase
    let coin_name = getCoinName();
    return {
      coinName: getCoinName(),
      showAreaSelector: false,
      showPayWaySelecter: false,
      showPaymentSelecter: false,
      showOrderDetail: false,
      curLocation: '',
      curLocationVal: '',
      curPayType: {},
      curPrice: {},
      pricesList: [],
      allPayTypes: {},
      ourServerId: ourServerId,
      postAction: '',
      locations: {},
      post_fields: {},
      coin_name,
      priceEmpty: false,
      pin: '',
      serial: '',
      showPointCardEditor: false,
      ICON_URI: RES_HOST + 'commonImg/store/',
      showDetail: false,
      isWeb: globalConfig.getHrefParamUndecode('web') === '1',
      infoIsActive: true,
      dialog: this.$store.state.store.dialog,
      pays: this.$store.state.store.pays,
      userInfo: {},
      isSdk: 1,
      tip: this.$store.state.store.tip,
      canShowContent: false,
      init: false,
      boolPaying: false
    };
  },
  beforeCreate() {
    this.$store.dispatch(GET_LOGIN_STATUS).then(login => {
      if (!login) {
        this.doLogin();
      } else {
        this.$store.dispatch(LOAD_INIT_DATA).then(res => {
          this.canShowContent = true;
          if (!res) {
            return;
          }
          if (res.game_id !== 161 || !res.role_id) {
            this.infoIsActive = true;
          }
          this.selectServerInfo(res);
          // 地区名称重定义
          const ourLocations = {
            HK: '香港特別行政區',
            MO: '澳門特別行政區',
            MY: '馬來西亞',
            SG: '新加坡',
            TW: '台灣地區'
          };
          this.curLocationVal = res.current_location;
          this.curLocation =
            ourLocations[this.curLocationVal] ||
            getLocationNameByVal(res.current_location);
          this.allPayTypes = res.paytype_list;
          this.locations = Object.assign({}, res.all_locations, ourLocations);
          // 上次有储值，默认上次储值渠道
          if (res?.paytype?.f_pay_type && res?.paytype?.pay_type) {
            let defaultPayType = {};
            for (let i = 0; i < this.allPayTypes.length; i++) {
              if (
                res?.paytype?.f_pay_type === this.allPayTypes[i]?.f_pay_type &&
                res?.paytype?.pay_type === this.allPayTypes[i]?.pay_type
              ) {
                defaultPayType = this.allPayTypes[i];
                this.curPayType = defaultPayType;
                this.showPayWaySelecter = false;
              } else {
                // 上次有储值，但渠道已经取消
                this.curPayType = res.paytype_list[0];
                this.showPayWaySelecter = true;
              }
            }
          } else {
            // 上次没储值
            this.curPayType = res.paytype_list[0];
            this.showPayWaySelecter = true;
          }
          this.curPrice = this.curPayType?.price_list[0].list[0];
          this.pricesList = this.curPayType?.price_list || [];
          this.userInfo = {
            userName: res.login_account,
            userId: res.user_id
          };
          // 保存初始渠道到vuex
          this.setPayTypes(this.curPayType);
          this.isSdk = getIsSdk();
          setDefaultPayType(this.curPayType);
        });
      }
    });
  },
  created() {
    storeHref();
    storeHrefParam();

    // 临时开始：银行汇款下架提示，下次看到直接这些代码直接删除即可
    try {
      const boolShowRangDate =
        new Date() < new Date('2025-08-27T11:00:00+08:00');
      const boolShowToday =
        new Date().toISOString().split('T')[0] !==
        globalConfig.getCookie('bank_pay_down');
      if (boolShowRangDate && boolShowToday) {
        this.showTip({
          txt: '【付款方式調整公告】各位玩家：\n\n由於遭到不法份子攻擊及利用，為保護玩家的資產安全，自2025年8月22日（本週五）上午11:00起，我們將緊急暫停【銀行匯款】的支付方式。暫停後，您仍可透過其他付款方式進行儲值。\n\n透過【銀行匯款】已儲值的遊戲內物品，仍可繼續正常使用。8月22日之後，已儲值的餘額仍可在遊戲內全額使用（例如購買物品或禮包等）。\n\n本次調整不會影響您的遊戲資料或帳戶安全。對於由此給您帶來的不便，我們深感抱歉。感謝您的理解與支持。',
          call: () => {}
        });
        globalConfig.setCookie(
          'bank_pay_down',
          new Date().toISOString().split('T')[0]
        );
      }
    } catch (e) {
      console.error(e);
    }
    // 临时结束：银行汇款下架提示，下次看到直接这些代码直接删除即可
  },
  computed: {
    showDialog() {
      return this.$store.state.dialog.showDialog;
    },
    languages() {
      return this.$store.state.store.languages;
    },
    iconURL() {
      return (
        RES_HOST +
        'commonImg/store/' +
        this.curPayType?.f_pay_type +
        '/mode2/' +
        this.curPayType?.pay_type +
        '.png'
      );
    },
    server() {
      return this.$store.state.store.dialog.ctrl.sfq;
    },
    role() {
      return this.$store.state.store.dialog.ctrl.role;
    },
    showPackageTips() {
      const payType = this.curPayType?.pay_type;
      return (
        this.curPrice.PRODUCT_TYPE === 'package' &&
        (payType === 'mycard_ingame' || payType === 'mycard_ingame_tw')
      );
    },
    showBank() {
      return (
        this.curPayType?.pay_type === 'virtual_account' &&
        !this.showPayWaySelecter
      );
    },
    showStoreTips() {
      return this.$store.state.store.showStoreTips;
    }
  },
  directives: {
    fixing: {
      // 自定义指令, 作用：底部超长适配
      update: function () {
        try {
          const maxWidth = 640;
          const changeLineWidth = 520;
          const detailEle =
            document.getElementsByClassName('order-detail-info')[0];
          const detailWrap =
            document.getElementsByClassName('detail-container')[0];
          const detailWidth = detailEle.getBoundingClientRect().width;
          // 换行
          if (detailWidth > changeLineWidth) {
            detailWrap.classList.add('Prefix');
          }
          // 换行还是不够,缩小字体
          if (detailWidth > maxWidth) {
            detailEle.classList.add('scale');
          }
        } catch {}
      }
    }
  },
  methods: {
    setInitFinish() {
      if (this.init) {
        return;
      }
      this.init = true;
    },
    doLogin() {
      const twStoreHref = getGlobalGetGotoLink({ link: window.location.href });
      window.location.href =
        `https://pay.3syua.com/platform/login.html?gameId=161&forward=` +
        encodeURIComponent(twStoreHref);
    },
    controlAreaShow() {
      if (this.role.id === 0 || !this.role.id) {
        this.showSfq();
        return;
      }
      this.showAreaSelector = true;
      this.showPointCardEditor = false;
    },
    controlDisplay() {
      this.showPayWaySelecter = !this.showPayWaySelecter;
      this.showPointCardEditor = false;
    },
    selectServerInfo(res) {
      if (res.game_id === 161) {
        if (res.server_id) {
          const server = {
            ctrlId: 'sfq',
            sid: res.server_sid,
            id: res.server_id,
            txt: res.server_name
          };
          this.doSelect(server);
        }
        if (res.role_id) {
          const role = {
            ctrlId: 'role',
            id: res.role_id,
            txt: res.role_name
          };
          this.doSelect(role);
        } else {
          this.setInitFinish();
        }
      }
    },
    goLogOut() {
      this.$store.dispatch(GO_LOGOUT).then(() => {
        this.doLogin();
      });
    },
    hideAreaSelector(area) {
      this.curLocation = area.name;
      this.curLocationVal = area.value;
      this.showAreaSelector = false;
      this.$store.dispatch(RELOAD_WAY_BY_LOCA, area.value).then(success => {
        if (success) {
          this.setInitFinish();
          let allPayTypes = getPayTYpeListStore();
          this.allPayTypes = allPayTypes;
          const roleId =
            this.$store?.state?.store?.dialog?.ctrl?.role?.id || '';
          const roleName =
            this.$store?.state?.store?.dialog?.ctrl?.role?.txt || '';
          const serverId =
            this.$store?.state?.store?.dialog?.ctrl?.sfq?.sid || '';
          updateCommonParamsInfo({
            roleId,
            roleName,
            serverId
          });
          window.webstorev0DataLayer.push({
            eventName: 'bind',
            eventValue: {
              role_id: roleId,
              role_name: roleName,
              server_id: serverId
            }
          });
          if (!area.fromWatch) {
            this.showPayWaySelecter = true;
          }
        }
      });
    },
    showFeebackPage() {
      // 判断是否web端页面，如果是，跳到web端的临时工单页
      if (globalConfig.getHrefParamUndecode('web') === '1') {
        window.open(`https://service.${mainHost}` + window.location.search);
      } else {
        bridge.callSdkMethod(OPEN_BROSWER_METHOD, {
          url: FEEKBACK_URL,
          loginDir: 1,
          appendParams: 1
        });
      }
    },
    selectPayMent(payment) {
      this.showPaymentSelecter = false;
      this.curPrice = payment;
      window.webstorev0DataLayer.push({
        eventName: 'select_product',
        eventReason: 'click_select',
        eventValue: {
          product_type: payment?.PRODUCT_TYPE || '',
          cp_product_id: payment?.CP_PRODUCT_ID || '',
          product_id: payment?.PRODUCT_ID || '',
          product_num: 1,
          product_currency: payment?.CURRENCY || '',
          product_money: payment?.GAME_AMOUNT || ''
        }
      });
    },
    selectPayType(payType) {
      // 是否已选角色
      if (this.server.id === 0 || this.role.id === 0) {
        this.showSfq('sfq');
      } else {
        this.showPayWaySelecter = false;
        this.curPayType = Object.assign({}, payType);
        this.pricesList = payType?.price_list;
        this.curPrice = payType?.price_list[0].list[0];
        window.webstorev0DataLayer.push({
          eventName: 'select_product',
          eventReason: 'auto_select',
          eventValue: {
            product_type: this.curPrice?.PRODUCT_TYPE || '',
            cp_product_id: this.curPrice?.CP_PRODUCT_ID || '',
            product_id: this.curPrice?.PRODUCT_ID || '',
            product_num: 1,
            product_currency: this.curPrice?.CURRENCY || '',
            product_money: this.curPrice?.GAME_AMOUNT || ''
          }
        });
        // 保存curPayType到vuex
        this.setPayTypes(this.curPayType);
        window.webstorev2DataLayer.push({
          eventName: 'select_channels',
          eventReason: 'click_select',
          eventValue: {
            f_pay_type: payType.f_pay_type,
            pay_type: payType.pay_type,
            local_currency: payType.currency
          }
        });
      }
    },

    payWidthPointCard({ pin, serial }) {
      if (this.boolPaying) {
        return;
      }
      this.boolPaying = true;
      if (this.server.id === 0 || this.role.id === 0) {
        this.showSfq('sfq');
        this.boolPaying = false;
      } else {
        this.pin = pin;
        this.serial = serial;
        this.checkLoginAndPost();
      }
    },
    postOrder() {
      if (this.boolPaying) {
        return;
      }
      this.boolPaying = true;
      if (
        this.curPayType.type == NEED_PIN_ONLY ||
        this.curPayType.type == NEED_PIN_SERIAL
      ) {
        this.infoIsActive = false;
        this.showPointCardEditor = true;
        this.showOrderDetail = false;
        this.boolPaying = false;
      } else {
        this.checkLoginAndPost();
      }
    },
    checkLoginAndPost() {
      this.$store
        .dispatch(GET_LOGIN_STATUS)
        .then(login => {
          if (!login) {
            this.boolPaying = false;
            this.doLogin();
          } else {
            this.doPostORder();
          }
        })
        .catch(e => {
          this.boolPaying = false;
          console.error(e);
        });
    },
    doPostORder() {
      if (undefined == this.curPrice) {
        this.priceEmpty = true;
        this.boolPaying = false;
        return;
      }
      let params = {
        gameId: 161,
        productId: this.curPrice.PRODUCT_ID,
        roleName: this.role.txt,
        serverName: this.server.txt,
        roleId: this.role.id,
        userName: this.userInfo.userName,
        f_pay_type: this.curPayType?.f_pay_type,
        location: this.curLocationVal,
        paytype: this.curPayType?.pay_type,
        amount: this.curPrice?.TRANS_AMOUNT,
        currency: this.curPrice?.CURRENCY,
        amountDesc: this.curPrice?.TRANS_AMOUNT,
        productDesc:
          this.curPrice?.CP_PRODUCT_DESC || this.curPrice?.PRODUCT_DESC || '',
        serverId: this.server.id,
        server_sid: this.server.sid,
        pin: this.pin,
        curReferer: location.hostname,
        serial: this.serial,
        remark: this.curPrice.REMARK,
        language: TW_STORE_LANG,
        cid: globalConfig.getHrefParamUndecode('cid') || '',
        scid: globalConfig.getHrefParamUndecode('scid') || '',
        cpProductId: this.curPrice?.CP_PRODUCT_ID || '',
        productType: this.curPrice?.PRODUCT_TYPE || '',
        loginAccount: this.userInfo.userName,
        uid: this.userInfo.userId,
        ...getGlobalGetLinkParams()
      };
      setPostInfo(params);
      window.webstorev0DataLayer.push({
        eventName: 'select_submit',
        eventValue: {
          product_type: this.curPrice?.PRODUCT_TYPE || '',
          cp_product_id: this.curPrice?.CP_PRODUCT_ID || '',
          product_id: params?.productId || '',
          product_num: '1',
          product_currency: params?.currency || '',
          product_money: params?.amount || '',
          local_currency: params?.currency,
          local_money: params?.amount || '',
          f_pay_type: params?.f_pay_type || '',
          pay_type: params?.paytype || '',
          is_coupon: 0,
          coupon_typeid: '',
          coupon_type_name: '',
          coupon_id: '',
          coupon_start_time: '',
          coupon_end_time: '',
          coupon_local_money: '',
          coupon_discount: ''
        }
      });
      let timmap = new Date().getTime();
      this.$store
        .dispatch(POST_ORDER, params)
        .then(
          function ({ data, result, res }) {
            storeCurLocation(this.curLocationVal);
            setDefaultPrice(this.curPrice);
            setDefaultPayType(this.curPayType);
            setWebviewPageFlag();
            switch (data.type) {
              // type=1 GET方式跳转
              case PAY_REQUEST_GET:
                {
                  const redirectUrl = data.redirect_url;
                  location.href = redirectUrl;
                }
                break;
              // type=2 需要构造一个FORM表单 POST跳转
              case PAY_REQUEST_POST:
                // eslint-disable-next-line no-lone-blocks
                {
                  this.postAction = data.redirect_url;
                  this.post_fields = data.post_fields;
                  this.$nextTick(() => {
                    document.querySelector('#postOrderToBank').click();
                  });
                }
                break;
              // type=5 直接在页面显示充值成功
              case SHOW_RESULT_PAGE:
                {
                  let encodeParamStr = window.b64EncodeUnicode(
                    JSON.stringify(params)
                  );
                  let patam = {
                    result,
                    msg: res?.msg,
                    game_id: 161,
                    game_name: '日理萬姬',
                    server_id: this.server.id,
                    server_name: this.server.txt,
                    server_sid: this.server.sid,
                    order_id: data.order_id,
                    exchange_timestamp: timmap,
                    store_url_params: encodeParamStr
                  };
                  let pasrams = qs.stringify(patam);
                  let href = STORE_PAGE_BASE_URL + pasrams + '#/result';
                  location.href = href;
                }
                break;
              case BROWSER_PAY:
                {
                  const redirectUrl = data.redirect_url;

                  if (bridge.runInsdk()) {
                    bridge.callSdkMethod(OPEN_BROSWER_METHOD, {
                      url: redirectUrl,
                      loginDir: 0,
                      appendParams: 0
                    });
                    this.$router.push('browserPay');
                  } else {
                    location.href = redirectUrl;
                  }
                }
                break;
            }
            this.boolPaying = false;
          }.bind(this)
        )
        .catch(e => {
          this.boolPaying = false;
          console.error(e);
        });
    },
    infoLeave() {
      console.log('info face has done!');
    },
    showGame() {
      this.showDialogTw('game');
    },
    showSfq() {
      if (!this.init) {
        return;
      }
      let dialog = this.dialog;
      if (dialog.ctrl.game.id == 0) {
        this.showGame();
      } else {
        if (!this.dialog.lists.sfqs.length) {
          const that = this;
          this.getSfqs(function () {
            that.showDialogTw('sfq');
          });
        } else {
          this.showDialogTw('sfq');
        }
      }
    },

    showRole() {
      if (!this.init) {
        return;
      }
      let dialog = this.dialog;
      if (dialog.ctrl.game.id == 0) {
        this.showGame();
      } else if (dialog.ctrl.sfq.id == 0) {
        this.showSfq();
      } else {
        if (!this.dialog.lists.roles.length) {
          const that = this;
          this.getRole(function () {
            that.showDialogTw('role');
          });
        } else {
          this.showDialogTw('role');
        }
      }
    },
    getSfqs(fn) {
      this.changeDialogLoaded(false);
      let self = this;
      let selObj = this.$store.state.store.dialog.ctrl;
      let gameId = selObj.game.id;
      let key = 'SFQS_' + gameId;

      let tipCall = function () {
        this.showDialogTw('game');
      };

      let succ = function (res) {
        Api.log(res);
        // this.dialog.isLoaded = true;
        self.changeDialogLoaded(true);
        self.changeDialogSfqLen(res.data.length);
        self.changeDialoglistsSfq(
          res.data.length > 0
            ? res.data
            : [{ NAME: '暫無伺服器，請重新選擇！' }]
        );
        typeof fn === 'function' && fn();
        res.isAjax && Api.cacheMode(key, res.data);
      };

      let fail = function (res) {
        // this.dialog.isLoaded = true;
        this.changeDialogLoaded(true);
        Api.log(res);
        this.hideDialog('sfq');
        this.showTip({
          txt: '獲取伺服器失敗！',
          call: tipCall.bind(this)
        });
      };

      Api.ajax({
        localKey: key,
        url: '//gstore.3syua.com/ajax/server_list',
        type: 'get',
        dataType: 'jsonp',
        data: {
          game_id: gameId
        }
      }).then(succ.bind(this), fail.bind(this));
    },
    checkInfo() {
      if (this.server.id === 0 || this.role.id === 0) {
        this.showSfq('sfq');
      } else {
        this.showOrderDetail = true;
      }
    },
    getRole(fn) {
      this.changeDialogLoaded(false);
      let self = this;
      let selObj = this.$store.state.store.dialog.ctrl;
      let gameId = selObj.game.id;
      let sfqId = selObj.sfq.id;
      let key = 'ROLE_' + gameId + '_' + sfqId;

      let succ = function (res) {
        Api.log(res);
        self.changeDialogLoaded(true);
        self.changeDialogRolesLen(res.data.length);
        self.changeDialoglistsRole(
          res.data.length > 0
            ? res.data
            : [{ roleName: '暫無角色，請重新選擇！' }]
        );
        typeof fn === 'function' && fn();
        res.isAjax && Api.cacheMode(key, res.data);
      };
      Api.ajax({
        localKey: key,
        url: '//gstore.3syua.com/ajax/get_user_role/',
        type: 'get',
        dataType: 'jsonp',
        data: {
          game_id: gameId,
          server_id: sfqId
        }
      }).then(succ.bind(this), succ.bind(this));
    },
    ...mapMutations([
      'setGameList',
      'showDialogTw',
      'hideDialog',
      'showTip',
      'changeDialogId',
      'changeDialogLoaded',
      'changeDialogSfqLen',
      'changeDialogRolesLen',
      'changeDialoglistsSfq',
      'changeDialoglistsRole',
      'doSelect',
      'setPayTypes',
      'setAccount'
    ])
  },
  components: {
    AreaSelecter,
    PaymentSelecter,
    PayWaySelecter,
    Dialog,
    PointCard,
    dialogs,
    bank,
    tips
  },
  watch: {
    'role.id': {
      handler(newVal) {
        if (newVal && parseInt(newVal, 10) !== 0) {
          this.hideAreaSelector({
            name: this.curLocation,
            value: this.curLocationVal,
            fromWatch: 1
          });
          this.setAccount();
        }
      }
    },
    'server.id': {
      handler(newVal) {
        if (newVal) {
          this.setAccount();
        }
      }
    },
    showStoreTips(newVal, oldVal) {
      if (newVal) {
        this.showDialogTw('store-tips');
      }
    }
  }
};
</script>

<style lang="scss">
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.6);
  &.pay {
    z-index: 101;
  }
  .loading {
    top: 50%;
    left: 50%;
    width: 80px;
    height: 40px;
    background: none;
    margin-top: -20px;
    margin-left: -40px;
    position: absolute;
  }
  .loading-item {
    width: 8px;
    height: 100%;
    margin-left: 8px;
    border-radius: 4px;
    display: inline-block;
    background: #f3a069;
    animation: load 1s ease infinite;
  }
  @keyframes load {
    0%,
    100% {
      background: #f3a069;
      transform: scale(1, 1);
    }
    50% {
      background: #f2d1a7;
      transform: scale(1, 1.6);
    }
  }
  .loading-item:nth-of-type(2) {
    animation-delay: 0.2s;
  }
  .loading-item:nth-of-type(3) {
    animation-delay: 0.4s;
  }
  .loading-item:nth-of-type(4) {
    animation-delay: 0.6s;
  }
  .loading-item:nth-of-type(5) {
    animation-delay: 0.8s;
  }
}
</style>
